<template>
  <div class="loading-page" v-if="visible">
    <div class="loading-content">
      <div class="loading-spinner">
        <img class="loading-img" src="https://lbs-nfncb.nfncb.cn/gzmap/img/loading.png" alt="">
        <!-- <div class="spinner"></div> -->
      </div>
      <div class="loading-text">加载中...</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.loading-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fad4d3;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  width: 300px;
  height: 276px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  width: 100%;
  height: 100%;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #1989fa;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  font-size: 32px;
  color: #666;
  font-weight: 500;
}
.loading-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>

